import React from 'react';
import type { Scenario } from '../../types/quote';
import { PaymentBreakdown } from './PaymentBreakdown';
import { CashToClose } from './CashToClose';
type ScenarioCardProps = {
  scenario: Scenario;
  label: string;
  framed: boolean;
};
export function ScenarioCard({
  scenario,
  label,
  framed
}: ScenarioCardProps) {
  return <article aria-label={`${scenario.program} scenario`} className={`flex h-full flex-col gap-7 ${framed ? 'rounded-[28px] bg-white p-5 ring-1 ring-navy-100 sm:p-6' : ''}`} data-id="element-131" data-mp="3nm4kgifk7qtp">
      <div data-id="element-132" data-mp="eixyi7bqdnl">
        <p className="text-xs font-extrabold text-navy-500" data-id="element-133" data-mp="e942jj5rmcm">{label}</p>
        <h3 className="mt-0.5 text-2xl font-black tracking-tight" data-id="element-134" data-mp="57ljc31y6gsp">{scenario.program}</h3>
        <dl className="mt-4 grid grid-cols-2 gap-2" data-id="element-135" data-mp="a5wt6ds8srax">
          <div className="rounded-[20px] bg-navy-50 px-4 py-3" data-id="element-136" data-mp="a7pz1qv177hv">
            <dt className="text-xs font-bold text-navy-500" data-id="element-137" data-mp="f61ag60z5q27">Interest rate</dt>
            <dd className="mt-0.5 text-xl font-black tabular-nums" data-id="element-138" data-mp="j5jw540me563">{scenario.rate}</dd>
          </div>
          <div className="rounded-[20px] bg-navy-50 px-4 py-3" data-id="element-139" data-mp="95jo3wudncjy">
            <dt className="text-xs font-bold text-navy-500" data-id="element-140" data-mp="466rikdper46">APR</dt>
            <dd className="mt-0.5 text-xl font-black tabular-nums" data-id="element-141" data-mp="44m033moroaj">{scenario.apr}</dd>
          </div>
        </dl>
      </div>
      <PaymentBreakdown scenario={scenario} data-id="element-142" data-mp="3veb5gdjx78by" />
      <CashToClose scenario={scenario} data-id="element-143" data-mp="3qeggifjpgstj" />
    </article>;
}